<ul class="Topics-mobile" *ngIf="topics.length > 0">
  <li *ngFor="let topic of getSortedTopics();" [class]="isTopicFollowed(topic.id) ? 'Added' : 'Add'">
    <a [routerLink]="['/site/topic', topic.id]">{{ topic.name }}</a>
    <span
      matTooltip="{{ isTopicFollowed(topic.id) ? 'Remove topic' : 'Add topic' }}"
      matTooltipPosition="above"
      (click)="toggleTopicFollowing(topic, $event)">
    </span>
  </li>
</ul>